module.exports = __webpack_public_path__ + "ranking-diagram.67d72a082851f324d67e53c336d5dd2e.png";